import { useEffect, useState } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { Route, Router, useNavigate, useParams } from 'react-router-dom';
import { Surveys } from './Surveys';

const SurveyRedirect = () => {

    useEffect(() => {
        window.location.href = "/chooseApp";
    }, [])

    return (
        <>

        </>
    );
};

export default SurveyRedirect;
